import { render, staticRenderFns } from "./tableedit.vue?vue&type=template&id=c97c3380&"
import script from "./tableedit.vue?vue&type=script&lang=js&"
export * from "./tableedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports